
export default {
  name: 'MegasredaRecomendedAuthorBlocksMaterialsCard',
  props: {
    material: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSetShow: false,
    }
  },
  computed: {
    title() {
      return this.material?.title ? this.material.title : this.preText
    },
    preText() {
      if (this.material?.text) {
        const text = this.material.text
        if (text?.blocks?.length) {
          let preText = text.blocks?.filter(
            (block) => block.type === 'paragraph' || block.type === 'header'
          )
          preText = preText.slice(0, 1).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<(.|\n)*?>/g, '')
          return sanitizeText
        }
      }
      return ''
    },
    authorName() {
      if (this.material?.author?.type === 'COMPANY') {
        return this.material.author.company?.title
          ? this.material.author.company.title
          : this.material.author.username
      } else {
        return this.material?.author?.profile?.firstName &&
          this.material?.author?.profile?.lastName
          ? `${this.material.author.profile.firstName} ${this.material.author.profile.lastName}`
          : this.material.author.username
      }
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView && !this.isSetShow) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/article', {
        username: this.material.author.username,
        articleId: this.material._id,
      })
      this.isSetShow = true
    },
  },
}
